import { render, staticRenderFns } from "./VuebaseLayout.vue?vue&type=template&id=b6eab8a4&scoped=true"
import script from "./VuebaseLayout.vue?vue&type=script&lang=js"
export * from "./VuebaseLayout.vue?vue&type=script&lang=js"
import style0 from "./VuebaseLayout.vue?vue&type=style&index=0&id=b6eab8a4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6eab8a4",
  null
  
)

export default component.exports